import { Icon } from './Icon';

/** База внешек: кадр с горизонтом и солнцем. */
export function ImageIcon({ size }: { size?: number }) {
  return (
    <Icon size={size}>
      <path d="M1.6 2.5 h10.8 v9 H1.6 Z" />
      <circle cx="4.8" cy="5.4" r="1.1" />
      <path d="M2.5 10.1 L5.8 7.2 L8.1 9.3 L9.7 8.1 L11.5 10.1" />
    </Icon>
  );
}
